import { render, staticRenderFns } from "./v8.vue?vue&type=template&id=7982803f&scoped=true&"
import script from "./v8.vue?vue&type=script&lang=js&"
export * from "./v8.vue?vue&type=script&lang=js&"
import style0 from "./v8.vue?vue&type=style&index=0&id=7982803f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982803f",
  null
  
)

export default component.exports